import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import { InputGroup, InputGroupText, Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import
{
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import
{
  getSecuritys as onGetSecuritys,
  addNewSecurity as onAddNewSecurity,
  updateSecurity as onUpdateSecurity,
} from "../../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";
import NewPhoneInputComponent, { extractPhoneDetails } from "../../../Components/Common/PhoneInput/PhoneInputComponent";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
  isValidPhoneNumber
} from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { lireRoleSession } from "../../../espace";

/**
 * Copie dans le presse-papier, avec un retour visible.
 *
 * navigator.clipboard n'existe qu'en contexte sécurisé : en HTTPS il est là,
 * mais pas sur une ouverture en http:// pendant un développement local. Le
 * repli par un champ hors écran couvre ce cas plutôt que d'échouer en silence.
 */
const copierTexte = async ( texte, messageSucces ) =>
{
  try
  {
    if ( navigator.clipboard && window.isSecureContext )
    {
      await navigator.clipboard.writeText( texte );
    } else
    {
      const champ = document.createElement( "textarea" );
      champ.value = texte;
      champ.style.position = "fixed";
      champ.style.opacity = "0";
      document.body.appendChild( champ );
      champ.select();
      document.execCommand( "copy" );
      document.body.removeChild( champ );
    }
    toast.success( messageSucces, { autoClose: 2000 } );
  } catch ( err )
  {
    toast.error( "Copie impossible", { autoClose: 2000 } );
  }
};

/** Le message prêt à coller dans WhatsApp ou un SMS. */
const messageIdentifiants = ( agent ) =>
  [
    `Bonjour ${ agent.username },`,
    "",
    `Vous etes agent de controle pour « ${ agent.event?.nom || "l'evenement" } ».`,
    "",
    "Ouvrez l'application Takci, puis « Je suis agent de controle »",
    "sur l'ecran de connexion.",
    "",
    `Telephone : ${ agent.telephone || "" }`,
    `Identifiant de connexion : ${ agent.id_connexion }`,
  ].join( "\n" );

const Security = ( props ) =>
{
  const [ loading, setLoading ] = useState( true );

  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric"
    } );
    return dateObject;
  }

  const history = useHistory();
  const [ formData1, setFormData1 ] = useState( {} );
  const dispatch = useDispatch();
  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).accessToken
    : null;

  // const { securitys, isSecurityCreated, isSecuritySuccess, error } =
  //   useSelector( ( state ) => ( {
  //     securitys: state.Security.securitys,
  //     isSecurityCreated: state.Security.isSecurityCreated,
  //     isSecuritySuccess: state.Security.isSecuritySuccess,
  //     error: state.Security.error,
  //   } ) );

  const [ agent, setAgent ] = useState( {} );
  const handleClickAgent = useCallback( ( arg ) =>
  {
    console.log( "arg: ", arg );
    setAgent(
      {
        agent_id: arg.agent_id,
        username: arg.username,
        telephone: arg.telephone,
        email: arg.email || "",
        event_id: arg.event_id,
      }
    );
  }, [] );

  const [ reducerValue, forceUpdate ] = useReducer( ( x ) => x + 1, 0 );

  function handleClick ()
  {
    forceUpdate();
  }

  const [ securitys, setSecuritys ] = useState( [] )
  const fetchSecurity = async () =>
  {
    try
    {
      const agent_securite = await axiosInstance.get( `/getagentfororga` );

      // console.log( "agent_securite: ", agent_securite );
      if ( agent_securite?.data )
      {
        setSecuritys( agent_securite.data.data );
        // console.log( "agent_securite data: ", agent_securite.data.data );
      }
    } catch ( err )
    {
      console.error( err );
    }
    setLoading( false );
  };


  const [ loadingEvenenement, setLoadingEvenements ] = useState( true )
  const [ evenements, setEvenements ] = useState( [] )
  const fetchEvenement = async () =>
  {
    setLoadingEvenements( true );
    try
    {
      const evenement = await axiosInstance.get( `/eventgetallfororga` );

      // console.log( "evenement: ", evenement );
      if ( evenement?.data )
      {
        setEvenements( evenement.data.data );
        // console.log( "evenement data: ", evenement.data.data );
      }
    } catch ( err )
    {
      console.error( err );
    }
    setLoadingEvenements( false );
  };

  const [ modalConfirmDelete, setModalConfirmDelete ] = useState( false );
  const [ securityGenerate, setSecurityGenerate ] = useState( "" );
  const [ isEdit, setIsEdit ] = useState( false );
  const [ isExportCSV, setIsExportCSV ] = useState( false );

  //delete Conatct
  const [ modal, setModal ] = useState( false );

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  const [ idConnected, setIdConnected ] = useState( null )

  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )
      if ( obj.data )
      {
        setIdConnected( obj.data.id )
      }
    }
  }

  useEffect( () =>
  {
    getSessionData()
  }, [] )


  useEffect( () =>
  {
    if ( roleSession === "ORGANISATEUR" )
    {
      fetchSecurity();
      fetchEvenement();
    }
  }, [ roleSession ] );


  const handleDisable = () =>
  {
    axiosInstance
      .put( `/disableagent/?id=${ agent.agent_id }` )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Agent contrôleur désactivé" );
        // dispatch( onGetSecuritys() );
        fetchSecurity()
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de la désactivation de l'agent de sécurité" );
      } );

    setModalConfirmDelete( false );

    setAgent( null );
  };

  const handleAble = ( agentId ) =>
  {
    axiosInstance
      .put( `/ableagent/?id=${ agentId }` )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Agent contrôleur activé" );
        // dispatch( onGetSecuritys() );
        fetchSecurity()
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de l'activation de l'agent de sécurité" );
      } );

    setModalConfirmDelete( false );

    setAgent( null );
  };

  // Column
  const columns = useMemo(
    () =>
      [
        {
          Header: props.t( "Pseudo" ),
          accessor: "username",
          filterable: false,
        },
        {
          // L'API renvoie « telephone » ; « numero » n'existe pas, la colonne
          // restait vide.
          Header: props.t( "Téléphone" ),
          accessor: "telephone",
          filterable: false,
        },
        {
          Header: props.t( "E-mail" ),
          accessor: "email",
          filterable: false,
          Cell: ( Cell ) =>
            Cell.row.original.email || (
              <span className="text-muted">—</span>
            ),
        },
        {
          Header: props.t( "Code de connexion" ),
          accessor: "id_connexion",
          filterable: false,
          // Le code devait être relevé à l'œil puis retapé dans WhatsApp :
          // huit chiffres, autant d'occasions de se tromper. Un clic le
          // copie, un autre prépare le message complet à transmettre.
          Cell: ( Cell ) => (
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">
                { Cell.row.original.id_connexion }
              </span>
              <button
                type="button"
                className="btn btn-sm btn-ghost-primary p-1"
                title={ props.t( "Copier le code" ) }
                onClick={ () => copierTexte(
                  String( Cell.row.original.id_connexion ),
                  props.t( "Code copié" )
                ) }
              >
                <i className="ri-file-copy-line fs-16"></i>
              </button>
              <button
                type="button"
                className="btn btn-sm btn-ghost-primary p-1"
                title={ props.t( "Copier le message complet" ) }
                onClick={ () => copierTexte(
                  messageIdentifiants( Cell.row.original ),
                  props.t( "Message copié, prêt à être transmis" )
                ) }
              >
                <i className="ri-share-forward-line fs-16"></i>
              </button>
            </div>
          ),
        },
        {
          Header: props.t( "Nom de l'événement" ),
          // Le nom arrive sous event.nom : « nom » à la racine n'existe pas.
          accessor: ( ligne ) => ligne.event?.nom || "",
          id: "nom_event",
          filterable: true,
          Cell: ( Cell ) => (
            <Link
              to={ `/evenements/${ Cell.row.original.event_id }` }
              className="text-primary"
            >
              { Cell.row.original.event?.nom || "—" }
            </Link>
          ),
        },
        {
          Header: props.t( "Début" ),
          accessor: "date",
          filterable: false,
          Cell: ( item ) => (
            <span>
              { moment( item.row.original.date ).format( "YYYY-MM-DD" ) } à { item.row.original.heure }
            </span>
          ),
        },
        {
          Header: props.t( "Fin" ),
          accessor: "date_fin",
          filterable: false,
          Cell: ( item ) => (
            <span>
              { moment( item.row.original.date_fin ).format( "YYYY-MM-DD" ) } à { item.row.original.heure_fin }
            </span>
          ),
        },
        {
          Header: props.t( "Status" ),
          accessor: "status_activation",
          filterable: true,
          Cell: ( item ) => (
            item.row.original.status_activation === 1 ?
              <span className="bg-success p-1 text-sm text-light rounded-lg">
                Activer
              </span> :
              <span className="bg-danger p-1 text-sm text-light rounded-lg">
                Désactiver
              </span>
          ),
        },
        // status_activation
        ...( roleSession === "ORGANISATEUR" ? [
          {
            Header: props.t( "Action" ),
            accessor: "id",
            filterable: false,
            Cell: ( item ) => (
              <ul className="list-inline hstack gap-2 mb-0">
                <Link
                  to={ `/security/${ item.row.original.id }` }
                  className="btn btn-sm btn-primary"
                  title="Voir"
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
                {
                  item.row.original.status_activation ?
                    <Link
                      to="#"
                      className="btn btn-sm btn-danger d-inline-block"
                      onClick={ ( e ) =>
                      {
                        e.preventDefault();
                        handleClickAgent( item.row.original )
                        setModalConfirmDelete( true );
                      } }
                    >
                      <i className=" bx bx-x align-middle"></i>
                      {/* Supprimer */ }
                    </Link> :
                    <Button
                      className="btn btn-sm btn-success d-inline-block"
                      onClick={ ( e ) =>
                      {
                        e.preventDefault();
                        handleAble( item.row.original.agent_id )
                      } }
                    >
                      <i className=" bx bx-check align-middle"></i>
                      {/* Supprimer */ }
                    </Button>
                }
              </ul>
            ),
          }
        ] : [] )
      ],
    [ roleSession ]
  );

  const SUPPORTED_FORMATS = [ "image/*" ];
  // validation
  const validation = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      username: "",
      telephone: "",
      email: "",
      event_id: "",
    },
    validationSchema: Yup.object( {
      username: Yup.string().required(
        props.t( "Veuillez renseigner le pseudo" )
      ),
      telephone: Yup.string().required(
        props.t( "Veuillez renseigner le telephone" )
      ).test(
        "is-valid-phone",
        props.t( "Numéro de téléphone invalide" ),
        ( value ) => Boolean( value ) && isValidPhoneNumber( value )
      ),
      // Facultatif : un agent de terrain n'a pas toujours d'adresse. Mais
      // s'il en donne une, elle doit être valide — sinon ses identifiants
      // partent dans le vide sans que personne ne le sache.
      email: Yup.string().email( props.t( "Adresse e-mail invalide" ) ),
      event_id: Yup.string().required(
        props.t( "Veuillez renseigner l'événement" )
      ),
    } ),
    onSubmit: ( values ) =>
    {
      console.log( "values: ", values );
      console.log( "Edit: ", isEdit );


      const instanceSecurity = {
        username: values.username,
        telephone: values.telephone,
        email: values.email || "",
        event_id: values.event_id,
      };

      // console.log("instanceSecurity: ", instanceSecurity);

      if ( isEdit )
      {
        try
        {
          const data = axiosInstance
            // Visait /updatecodepromo/ : la modification d'un agent partait
            // sur la route des codes de réduction, et n'aboutissait jamais.
            .put( `/updateagent/`, { id: agent.id, ...instanceSecurity } )
            .then( ( response ) =>
            {
              // dispatch(onUpdateSecurity(updateSecurity));
              validation.resetForm();
              toast.success( props.t( "Agent contrôleur modifié" ), {
                autoClose: 3000,
              } );
              fetchSecurity()
              // dispatch( onGetSecuritys() );
              handleClick();
            } )
            .catch( ( error ) =>
            {
              toast.error( props.t( "La modification de l’agent a échoué" ), {
                autoClose: 3000,
              } );
            } );

          // window.location.reload(true);
        } catch ( err )
        {
          console.error( err );
          toast.error( props.t( "La modification de l’agent a échoué" ), {
            autoClose: 2000,
          } );
        }
        fetchSecurity();
        // dispatch( onGetSecuritys() );
        setIsEdit( false );
      } else
      {
        // console.log("Ajout de code Promo: ", instanceSecurity);
        //  username, telephone, event_id
        try
        {
          const data = axiosInstance
            .post( `/createagent/`, instanceSecurity )
            .then( ( response ) =>
            {
              // console.log("Reponse sauvegarder avec success: ", response);

              // history.push("/security");
              validation.resetForm();
              toast.success( props.t( "Agent contrôleur ajouté" ), {
                autoClose: 3000,
              } );
              fetchSecurity();
              // dispatch( onGetSecuritys() );
              handleClick();
            } );
        } catch ( err )
        {
          console.error( err );
          toast.error( props.t( "L’ajout de l’agent a échoué" ), {
            autoClose: 3000,
          } );
        }
        fetchSecurity();
      }
      setModal( false );
    },
  } );


  document.title = props.t( "Agents contrôleurs | Takci" );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( "Agents contrôleurs" ) } pageTitle="Takci" />

          <Row>
            <Col lg={ 12 }>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      {
                        roleSession === "ORGANISATEUR" &&
                        <button
                          className="btn add-btn"
                          style={ { background: "#002437", color: "white" } }
                          onClick={ () =>
                          {
                            setModal( true )
                            fetchEvenement()
                          } }
                        >
                          <i className="ri-user-add-line me-1 align-bottom"></i>
                          { props.t( "Ajouter agents de sécurité" ) }
                        </button>
                      }

                      { securitys.length > 0 && (
                        <button
                          disabled={
                            securitys.length < 0
                          }
                          type="button"
                          className="btn"
                          style={ { color: "#eac22f" } }
                          onClick={ () => setIsExportCSV( true ) }
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{ " " }
                          { props.t( "Export" ) }
                        </button>
                      ) }
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={ 12 }>
              <Card id="securityList">
                <CardBody className="pt-0">
                  <div>
                    { !loading ? (
                      securitys.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={ isExportCSV }
                            onCloseClick={ () => setIsExportCSV( false ) }
                            data={
                              securitys.length > 0
                                ? securitys
                                : []
                            }
                          />

                          <TableContainer
                            columns={ columns }
                            data={
                              securitys
                            }
                            isGlobalFilter={ true }
                            isAddUserList={ false }
                            customPageSize={ 8 }
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                          // handleSecurityClick={ handleSecurityClicks }
                          />
                        </>
                      ) : (
                        <h2 className="text-center my-3">
                          Aucun agent disponible
                        </h2>
                      )
                    ) : (
                      <div className="text-center my-3">
                        <Loader style={ { color: "#014c94" } } />
                        <h2>Chargement...</h2>
                      </div>
                    ) }
                  </div>

                  <Modal
                    id="showModal"
                    style={ { maxWidth: 800 } }
                    isOpen={ modal }
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {/* { isEdit === true ? props.t( "Modifier Security" ) : props.t( "Ajouter un agent contrôleur" ) } */ }
                      { isEdit
                        ? props.t( "Modifier l’agent contrôleur" )
                        : props.t( "Ajouter un agent contrôleur" ) }
                    </ModalHeader>

                    <Form
                      onSubmit={ ( e ) =>
                      {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      } }
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={ 4 }>
                            <div>
                              <Label
                                htmlFor="username"
                                className="form-label"
                              >
                                { props.t( "Pseudo de l'agent" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="username"
                                id="username"
                                className="form-control"
                                placeholder={ props.t( "Entrez le pseudo" ) }
                                type="text"
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validation.handleChange }
                                onBlur={ validation.handleBlur }
                                value={ validation.values.username || "" }
                                invalid={
                                  validation.touched.username &&
                                    validation.errors.username
                                    ? true
                                    : false
                                }
                              />
                              { validation.touched.username &&
                                validation.errors.username ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.username }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div>
                              <Label
                                htmlFor="event_id"
                                className="form-label"
                              >
                                { props.t( "Evénements" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              {
                                loadingEvenenement ?
                                  <div>Chargement des événements...</div> :
                                  <Input
                                    name="event_id"
                                    id="event_id"
                                    className="form-control"
                                    type="select"
                                    validate={ {
                                      required: { value: true },
                                    } }
                                    onChange={ validation.handleChange }
                                    onBlur={ validation.handleBlur }
                                    value={ validation.values.event_id || "" }
                                    invalid={
                                      validation.touched.event_id &&
                                        validation.errors.event_id
                                        ? true
                                        : false
                                    }
                                  >
                                    <option value="" disabled>
                                      Selectionner l'événement
                                    </option>
                                    {
                                      evenements.map( ( item, key ) => (
                                        <option key={ key } value={ item.id }>{ item.nom }</option>
                                      ) )
                                    }
                                  </Input>
                              }

                              { validation.touched.event_id &&
                                validation.errors.event_id ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.event_id }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div>
                              <Label
                                htmlFor="telephone"
                                className="form-label"
                              >
                                { props.t( "Telephone" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              {/* Champ texte auparavant, alors que la
                                  validation exige le format international :
                                  l'organisateur devait deviner qu'il fallait
                                  taper « +229… ». Et un numéro local faisait
                                  échouer l'envoi des identifiants par SMS,
                                  qu'Africa's Talking refuse hors E.164. */}
                              <PhoneInput
                                international
                                defaultCountry="BJ"
                                id="telephone"
                                placeholder={ props.t( "Entrez le téléphone" ) }
                                value={ validation.values.telephone || "" }
                                onChange={ ( valeur ) =>
                                  validation.setFieldValue(
                                    "telephone",
                                    valeur || ""
                                  )
                                }
                                onBlur={ () =>
                                  validation.setFieldTouched( "telephone", true )
                                }
                                className={
                                  validation.touched.telephone &&
                                    validation.errors.telephone
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                              { validation.touched.telephone &&
                                validation.errors.telephone ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.telephone }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div>
                              <Label htmlFor="email" className="form-label">
                                { props.t( "E-mail" ) }
                              </Label>
                              <Input
                                name="email"
                                id="email"
                                className="form-control"
                                placeholder={ props.t( "Facultatif" ) }
                                type="email"
                                onChange={ validation.handleChange }
                                onBlur={ validation.handleBlur }
                                value={ validation.values.email || "" }
                                invalid={
                                  validation.touched.email &&
                                    validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              { validation.touched.email &&
                                validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.email }
                                </FormFeedback>
                              ) : (
                                <small className="text-muted">
                                  { props.t(
                                    "Ses identifiants lui seront envoyés par e-mail et par SMS."
                                  ) }
                                </small>
                              ) }
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={ () =>
                            {
                              setModal( false );
                              fetchSecurity();
                            } }
                            className="btn-light"
                          >
                            { props.t( "Fermer" ) }
                          </Button>

                          {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetSecuritys); }} > {props.t("Fermer")} </button> */ }
                          <Button
                            type="submit"
                            className="btn"
                            style={ { background: "#002437", color: "white" } }
                            id="add-btn"
                          >
                            { isEdit
                            
                              ? props.t( "Edit" )
                              : props.t( "Ajouter un agent contrôleur" ) }
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <Modal
                    id="showModalConfirmDelete"
                    style={ { maxWidth: 800 } }
                    isOpen={ modalConfirmDelete }
                    centered
                  >
                    <ModalBody className="py-3 px-5">
                      <div className="mt-2 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/gsqxdxog.json"
                          trigger="loop"
                          colors="primary:#014c94,secondary:#eac22f"
                          style={ { width: "100px", height: "100px" } }
                        ></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <h4>Êtes-vous sûr ?</h4>
                          <p className="text-muted mx-4 mb-0">
                            Êtes-vous sûr de vouloir désactiver cet agent ?
                          </p>
                        </div>
                      </div>
                      <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                        <button
                          type="button"
                          className="btn w-sm btn-light"
                          data-bs-dismiss="modal"
                          onClick={ () =>
                          {
                            setModalConfirmDelete( false );
                          } }
                        >
                          Fermer
                        </button>
                        <button
                          type="button"
                          className="btn w-sm btn-danger"
                          id="delete-organizer"
                          onClick={ handleDisable }
                        >
                          Oui, désactivez-le !
                        </button>
                      </div>
                    </ModalBody>
                  </Modal>

                  <ToastContainer closeButton={ false } />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
};

Security.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( Security ) );
